import { Service, ServiceInitializer, serviceViewsName } from 'elc-service';
import { InitializeTokenUseCase } from '../internal/use-cases/InitializeTokenUseCase';

const { name, version } = __serviceInfo__;

export class SignInFormService extends Service {
    constructor(serviceIntializer: ServiceInitializer) {
        super(name, version, serviceIntializer);

        this.registerView(serviceViewsName.SIGN_IN_SCREEN, () =>
            import(
                /* webpackChunkName: 'SingleSignOn' */
                '../exported/single-sign-on/SingleSignOn'
            )
        );
        this.registerView(serviceViewsName.SIGN_IN_FORM, () =>
            import(
                /* webpackChunkName: 'SignInForm' */
                '../exported/sign-in-form/SignInForm'
            )
        );

        this.registerView(serviceViewsName.SIGN_OUT_LINK, () =>
            import(
                /* webpackChunkName: 'SignOutLink' */
                '../exported/sign-in-form/SignOutLink'
            )
        );

        this.registerView(serviceViewsName.SIGN_IN_NAV_LINK, () =>
            import(
                /* webpackChunkName: 'SignInNavLink' */
                '../exported/nav-link/SignInNavLink'
            )
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public async start(drupalConfig: any) {
        await super.start(drupalConfig);
        const useCase = new InitializeTokenUseCase();
        await useCase.execute();
    }
}
